'use client';

import { createContext, useState } from 'react';
import { IntlProvider as OriginalIntlProvider } from 'react-intl';

// TODO: hard coded english translated messages here, this will eventually
//  need to be loaded from an API based on user preferences.
import messages from '@/i18n/compiled/en.json';

export interface LocaleContextData {
  locale: string;
  setLocale: (locale: string) => void;
}

const LocaleContext = createContext<LocaleContextData>({
  locale: 'en',
  setLocale: () => {},
});

export interface IntlProviderProps {
  children: any;
}

export function IntlProvider({ children }: IntlProviderProps) {
  const [locale, setLocale] = useState('en');

  const handleSetLocale = (newLocale: string) => {
    setLocale(newLocale);
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale: handleSetLocale }}>
      <OriginalIntlProvider locale={locale} messages={messages}>
        {children}
      </OriginalIntlProvider>
    </LocaleContext.Provider>
  );
}
